import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const Cta = styled(Button).attrs((props) => ({
  variant: "primary",
  width: "100%",
  ...props.theme.loginForm.cta,
  ...props,
}))``

export const FieldContainer = styled(Box).attrs((props) => ({
  ...props.theme.loginForm.fieldContainer,
}))``

export const RememberMeContainer = styled(Flex).attrs((props) => ({
  justifyContent: "space-between",
  textAlign: "left",
  ...props.theme.loginForm.rememberMeContainer,
  ...props,
}))``

export const ForgotPassword = styled(Button).attrs((props) => ({
  underline: true,
  variant: "text",
  ...props.theme.loginForm.forgotPassword,
}))``

export const Footnote = styled(Typography).attrs((props) => ({
  ...props.theme.loginForm.footnote,
  ...props,
}))``

export const SubscribeBox = styled(Box).attrs((props) => ({
  textAlign: "left",
  ...props.theme.loginForm.subscribeBox,
  ...props,
}))``
